// Shows a list page's counts as pills next to the page name in the top app bar.
// The component defines a `pageBadges` computed returning an array of strings, e.g. ['1,176'].
// Badges are pushed on mount (after the previous page's beforeDestroy has cleared its own)
// and kept in sync while the page is open.
export default {
    watch: {
        pageBadges(badges) {
            this.$store.commit('pageNameStore/setPageBadges', badges)
        }
    },
    mounted() {
        this.$store.commit('pageNameStore/setPageBadges', this.pageBadges)
    },
    beforeDestroy() {
        this.$store.commit('pageNameStore/setPageBadges', [])
    }
}
